export default __webpack_public_path__ + "static/media/999.a48410da.png";